import { useMediaQuery } from '@mui/material';
import { IUserProfileData } from '../../createAndEdit/types';
import { formatRecipientLabel } from '../../utils';

interface IDetailInfoBarProps {
  userProfile?: IUserProfileData;
  origin?: string;
  originUserName?: string;
  recipient?: string;
  label?: string;
}

const DetailInfoBar = (props: IDetailInfoBarProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const org = props.userProfile?.account || 'Concessionária';
  const senderName = props.originUserName;
  const originLabel = props.origin ? formatRecipientLabel(props.origin) : '';
  const recipientLabel = props.recipient ? formatRecipientLabel(props.recipient) : '';

  return (
    <div className={`${isMobile ? 'px-4' : 'px-6'} mb-2`}>
      <div className={`flex flex-col items-start gap-2 ${isMobile ? 'text-size-12' : 'text-size-14'}`}>
        <span className="font-family-sans-pro text-[#2A3740]" style={{ fontSize: '14px' }}>{props.label}</span>
        <div className={`flex mb-1 ${isMobile ? 'flex-col gap-1' : 'flex-row items-center gap-2'} font-bold ${isMobile ? 'text-size-14' : 'text-size-16'}`} style={{ color: '#344054' }}>
          {senderName && (
            <span className="text-color-darkest text-size-16">{senderName}</span>
          )}
          {recipientLabel && (org || originLabel || senderName) && (
            <>
              <span className="text-gray-300 text-size-16 mx-5">—</span>
              <span className="rioglyph rioglyph-user text-color-darkest text-size-16 shrink-0" aria-hidden />
              <span className="text-color-darkest text-size-16">{recipientLabel}</span>
            </>
          )}
        </div>
      </div>
      <div className="border-b border-gray-200 mt-2" />
    </div>
  );
};

export default DetailInfoBar;
